import { TrainingBillingRecord } from '../types/trainingBilling'

// Sample billing positions for the practices whose proforma/invoice
// was already issued. The others are generated from the practices.
export const trainingBillingRecords: TrainingBillingRecord[] = [
  {
    practiceId: 'prt-001',
    status: 'Fattura da fare',
    proforma: {
      progressive: 'PF-2026-001',
      issueDate: '2026-09-04',
      dueDate: '2026-10-04',
      number: 'PRO 118/2026',
    },
  },
  {
    practiceId: 'prt-003',
    status: 'Pagamento in revisione',
    invoice: {
      progressive: 'FT-2026-001',
      amount: 60,
      issueDate: '2026-09-16',
      dueDate: '2026-10-16',
      number: 'FT 402/2026',
    },
  },
  {
    practiceId: 'prt-007',
    status: 'Fattura pagata',
    proforma: {
      progressive: 'PF-2025-014',
      issueDate: '2025-06-02',
      dueDate: '2025-06-30',
      number: 'PRO 71/2025',
    },
    invoice: {
      progressive: 'FT-2025-021',
      contractNumber: '25.004',
      contractProduct: 'Formazione Lavoratori',
      amount: 240,
      issueDate: '2025-06-12',
      dueDate: '2025-07-12',
      paymentDate: '2025-07-03',
      proformaNumber: 'PRO 71/2025',
      number: 'FT 233/2025',
    },
  },
]
